import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TREATMENTS, PERSON_ROLES } from './incidentConstants';

export const InjurySection = ({ form, set }) => (
  <div className="space-y-4">
    <div className="flex items-center justify-between p-3 bg-rose-50 rounded-xl border border-rose-100">
      <div>
        <Label className="text-rose-800">Was anyone hurt?</Label>
        <p className="text-xs text-rose-600">Turn on to add injury details</p>
      </div>
      <Switch checked={form.injury_occurred} onCheckedChange={(v) => set('injury_occurred', v)} data-testid="incident-injury-toggle" />
    </div>
    {form.injury_occurred && (
      <div className="space-y-4 pl-1">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Injured person's name *</Label>
            <Input value={form.injured_person_name} onChange={(e) => set('injured_person_name', e.target.value)} data-testid="incident-injured-name" />
          </div>
          <div className="space-y-2">
            <Label>They are a</Label>
            <Select value={form.injured_person_role} onValueChange={(v) => set('injured_person_role', v)}>
              <SelectTrigger data-testid="incident-injured-role"><SelectValue placeholder="Select" /></SelectTrigger>
              <SelectContent>
                {PERSON_ROLES.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>
        <div className="space-y-2">
          <Label>Body part(s) affected</Label>
          <Input value={form.body_parts} onChange={(e) => set('body_parts', e.target.value)} placeholder="e.g. left hand, lower back" data-testid="incident-body-parts" />
        </div>
        <div className="space-y-2">
          <Label>What was the injury?</Label>
          <Textarea rows={2} value={form.injury_description} onChange={(e) => set('injury_description', e.target.value)} placeholder="e.g. cut, sprain, burn" data-testid="incident-injury-description" />
        </div>
        <div className="space-y-2">
          <Label>Treatment given</Label>
          <Select value={form.treatment} onValueChange={(v) => set('treatment', v)}>
            <SelectTrigger data-testid="incident-treatment"><SelectValue placeholder="Select treatment" /></SelectTrigger>
            <SelectContent>
              {TREATMENTS.map((t) => <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>
    )}
  </div>
);
